import type {
  Leadership,
  LeadershipType,
  OrganizationUnitListFormValues,
} from './OrganizationUnitLists.types.ts';

export const getOrganizationUnitListValues = (
  data: OrganizationUnitListFormValues & {
    leadershipInfo: {
      entraId: string;
      displayName: string;
      email: string;
    }[];
  },
) => ({
  id: data?.id || null,
  title: data?.title || '',
  order: data?.order || 1,
  type: data?.type || null,
  abbreviation: data?.abbreviation || '',
  parentAbbreviation: data?.parentAbbreviation || '',
  leadership: data?.leadershipInfo
    ? data?.leadershipInfo?.map((l: Leadership) => ({
        value: l.entraId,
        label: l.displayName,
        key: l.email,
      }))
    : null,
  selectable: data?.selectable || true,
});

export const getOrganizationUnitListData = (
  values: OrganizationUnitListFormValues & { leadership: LeadershipType[] | null },
) => ({
  abbreviation: values.abbreviation,
  leadership: values?.leadership?.map((item: LeadershipType) => ({
    entraId: item.value,
    displayName: item.label,
    email: item.key,
  })),
  order: Number(values.order) || 0,
  parentAbbreviation: values.parentAbbreviation,
  selectable: values.selectable,
  title: values.title,
  type: values.type,
});